module.exports = __webpack_public_path__ + "static/media/icon_doc.157da3fc.svg";